module.exports = __webpack_public_path__ + "img/logo.4668b23e.svg";